// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportOptOutHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentCreditReportOptOutHandler_optOut } from '@zg-rentals/ts-rent-payment-client';

import type { RentCreditReportOptOutWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface RentCreditReportOptOutHandler_optOut_Args {
  postData: RentCreditReportOptOutWebApiRequestDto;
}

export type RentCreditReportOptOutHandler_optOut_Options = UseMutationOptions<
  void,
  unknown,
  RentCreditReportOptOutHandler_optOut_Args
>;

/**
 * Opt out of rent reporting
 */
export const useRentCreditReportOptOutHandler_optOut = ({
  httpClient,
  ...options
}: Omit<RentCreditReportOptOutHandler_optOut_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentCreditReportOptOutHandler_optOut_Args) =>
      RentCreditReportOptOutHandler_optOut(args.postData, httpClient),
  });
};
